import React from 'react'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { Trans } from 'react-i18next'
import { useGetLanguageMapperGif } from '../../guided-tour-gifs/use-get-language-gif'

/** Wallbox card menu options step component */
export const AssignTariffToWallboxStep: React.FC = () => {
  const { breakpoints } = useTheme()
  const isMobile = useMediaQuery(breakpoints.down('sm'))

  const { assignTariffGif } = useGetLanguageMapperGif()

  return (
    <>
      <Trans i18nKey="emobility.tour.wallbox-card-menu-options" components={{ strong: <strong /> }} />

      <Box mt={4}>
        <img width={isMobile ? 200 : 300} src={assignTariffGif} alt="assign-tariff-to-wallbox" />
      </Box>
    </>
  )
}
